export function getdata() {
	let obj ={
		headData: [
			{
				title: "序号",
				prop: "xh",
				width: "55px",
				custom: true,
			},
			{
				title: "申报属期起",
				prop: "ssqq",
				width: "55px",
				custom: true,
			},
			{
				title: "申报属期止",
				prop: "ssqz",
				width: "55px",
				custom: true,
			},
			{
				title: "进项税额",
				prop: "jxse",
				width: "55px",
				custom: true,
			},
			{
				title: "一般项目进项税额",
				prop: "ybxmjxse",
				width: "55px",
				custom: true,
			},
			{
				title: "一般项目出口业务对应的进项税额",
				prop: "ybxmckywdyjxse",
				width: "55px",
				custom: true,
			},
			{
				title: "即征即退项目进项税额",
				prop: "jzjtxmjxse",
				width: "55px",
				custom: true,
			},
			{
				title: "即征即退项目出口业务对应的进项税额",
				prop: "jzjtxmckywdyjxse",
				width: "55px",
				custom: true,
			},
		],
		tableData:[
		],
	}
	return obj 
}
